module.exports = __webpack_public_path__ + "img/modal_img03.6709a216.png";